import type { ColumnsAvailableProps } from '../useColumnsFilter';

export const protolusColumnsAvailable: ColumnsAvailableProps = {
  creation_time: {
    title: 'Created At',
    key: 'creation_time',
    width: 130,
  },
  last_update_time: {
    title: 'Updated At',
    key: 'last_update_time',
    width: 130,
  },
  last_update_by: {
    title: 'Updated By',
    key: 'last_update_by',
  },
  created_by: {
    title: 'Created By',
    key: 'created_by',
  },
};

export const protolusColumnsOrder: (
  'creation_time' |
  'last_update_time' |
  'last_update_by' |
  'created_by'
)[] = [
  'creation_time',
  'last_update_time',
  'last_update_by',
  'created_by',
];

export const kaminoColumnsOrder: (
  'created_at' |
  'updated_at'
)[] = [
  'created_at',
  'updated_at',
];

export const kaminoColumnsAvailable: ColumnsAvailableProps = {
  created_at: {
    title: 'Created At',
    key: 'created_at',
    width: 130,
  },
  updated_at: {
    title: 'Updated At',
    key: 'updated_at',
    width: 130,
  },
};
